import { ApiServiceBase } from '@@/api/services/ApiServiceBase'
import type { ApiResponse, ApiPaginatedResponse } from '@@/api/types/Api'

export default class DocumentService extends ApiServiceBase {
  async all(query: string | null): Promise<ApiPaginatedResponse<object>> {
    const params = query ?? {}
    // Ensure page parameter is properly handled if not provided
    if (!params.page) {
      params.page = 1
    }
    return await this.call(`/v1/documents`, { params })
  }
  async current(): Promise<ApiResponse<object>> {
    return await this.call('/v1/documents/current')
  }
  async create(postData: object): Promise<ApiResponse<object>> {
    return await this.call('/v1/documents', postData)
  }
}
